module.exports = __webpack_public_path__ + "static/media/logo@2x.dc921744.png";